<template>
    <div class="containerCD">
        <v-row>
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-card>
                    <v-card-title class="pa-5 pb-3 primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-file-document-edit</v-icon>
                        <p style="color: white;">Asignar calificación </p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="pa-5 pt-4">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col md="6" offset-md="3">
                                    <span style="text-align: center;font-size: medium;">Tipo de Documento:</span>
                                    <p style="font-weight: 600; font-size: x-large;">{{ this.tipo }}</p>
                                </v-col>
                            </v-row>
                            <v-progress-linear :active="loading" :indeterminate="loading" color="primary"
                                class="mb-0"></v-progress-linear>
                            <v-row justify="center" style="margin-top: 2%;">
                                <div class="btnSI">
                                    <v-col class="justify-center align-center" cols="12" md="1" align="center" xs="4"
                                        justify="center">
                                        <v-container bg fill-height grid-list-md text-xs-center>
                                            <v-layout row wrap align-center>
                                                <v-flex>
                                                    <v-btn icon class="ma-2 align-center" @click="Anterior()"
                                                        :loading="loading2" :disabled="disableL">
                                                        <v-icon>
                                                            mdi-chevron-left
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-col>
                                </div>
                                <div class="btnSI">
                                    <v-col cols="12" md="1">
                                        <v-container bg fill-height grid-list-md text-xs-center>
                                            <v-layout row wrap align-center>
                                                <v-flex>
                                                    <v-btn icon class="ma-2 align-center" @click="Siguiente()"
                                                        :loading="loading3" :disabled="disableR">
                                                        <v-icon>
                                                            mdi-chevron-right
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-col>
                                </div>
                            </v-row>
                            <v-row justify="center" style="margin-top: 2%;">
                                <div class="btnNO">
                                    <v-col class="hidden-sm-and-down justify-center align-center" cols="12" md="1"
                                        align="center" xs="4" justify="center">
                                        <v-container bg fill-height grid-list-md text-xs-center>
                                            <v-layout row wrap align-center>
                                                <v-flex>
                                                    <v-btn icon class="ma-2 align-center" @click="Anterior()"
                                                        :loading="loading2" :disabled="disableL">
                                                        <v-icon>
                                                            mdi-chevron-left
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-col>

                                </div>
                                <v-col cols="12" md="8">
                                    <div class="border pa-4" style="height: 70vh;" id="ver">
                                    </div>
                                    <div v-if="loading == false"
                                        style="display: grid; place-items: center; font-size: x-large;">
                                        {{ this.contador }}/{{ this.paginas }}
                                    </div>
                                </v-col>
                                <div class="btnNO">
                                    <v-col cols="12" md="1">
                                        <v-container bg fill-height grid-list-md text-xs-center>
                                            <v-layout row wrap align-center>
                                                <v-flex>
                                                    <v-btn icon class="hidden-sm-and-down ma-2 align-center"
                                                        @click="Siguiente()" :loading="loading3" :disabled="disableR">
                                                        <v-icon>
                                                            mdi-chevron-right
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-col>
                                </div>
                            </v-row>
                            <v-row>
                                <v-col md="6" offset-md="3">
                                    <span style="text-align: center;font-size: medium;">Calificar Documento: {{ this.tipo
                                    }}</span>
                                    <v-radio-group v-model="respuesta" row :rules="[v => !!v || 'Opción requerida']">
                                        <v-radio label="No conforme" value="NC"></v-radio>
                                        <v-radio label="Conforme" value="C"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row v-if="mostrarcomentario">
                                <v-col md="6" offset-md="3">
                                    <br />
                                    <span style="text-align: center;font-size: medium;">Comentarios:</span>
                                    <v-textarea :counter="500" maxlength="500" :rules="rulestextarea" outlined
                                        v-model="comentarios" name="input-7-4">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                        <v-row justify="center" class="mb-8">
                            <v-btn class="ma-2" color="#536DFE" @click="Guardar();" style="color:white"
                                :disabled="disabled">Guardar</v-btn>
                            <v-btn class="ma-2" @click="limpiar()" color="default" :disabled="disabled">Limpiar</v-btn>
                            <v-btn class="ma-2" @click="Cancelar()" color="error" :disabled="disabled">Cancelar</v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Archivos from '@/services/Archivos/Archivos.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    export default {
        title() {
            return this.$route.meta.title
        },
    data: function () {
        return {
            loading: true,
            loading2: false,
            loading3: false,
            disableL: true,
            disableR: false,
            paginas: 0,
            contador: 1,
            /* */
            valid: true,
            tipoDoc: {
                opcionesDoc: [],
                doclave: '',
                dodescrip: ''
            },
            disabled: false,
            comentarios: null,
            tipo: null,
            respuesta: null,
            docid: null,
            validacomentario: false,
            mostrarcomentario: false,
            rulestextarea: [v => !!v || 'Campo requerido',
            v => {
                if (v == null) {
                    return true
                }
                else {
                    // return 'Mínimo 12 Carácteres'
                    if (v.trim().length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.trim().length > 500) {
                        return 'Máximo 500 Carácteres'
                    }
                    else
                        return true
                }
            },
            ],
            datos: null,
            media: [{
                src: '@/',
                type: ''
            }],
            docarchivo: '',
        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    watch: {
        async 'respuesta'(val) {
            this.mostrarcomentario = val == 'NC' ? true : false
            this.comentarios = val == 'C' ? null : this.comentarios
        },
        async 'comentarios'(val) {
            if (val != null) {
                this.comentarios = val.trim()
                if (val.length == 0) {
                    this.comentarios = null
                }
            }
        },
        'contador'(val) {
            this.disableL = val == 1 ? true : false;
            this.disableR = val == this.paginas ? true : false;
        },
        'paginas'(val) {

        }
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        await this.ObtenenerDatosDocumento();

    },
    methods: {
        Anterior() {
            this.disableL = true;
            if (this.contador == 1) {
                this.contador == 1;
                this.disableL = true;
            }
            else {
                this.loading = true;
                this.loading3 = true;
                this.loading2 = true;
                this.disableL = false;
                this.disableR = false;
                this.contador = this.contador - 1
                if (document.querySelector("iframe") != null) {
                    document.querySelector("iframe").remove();
                }
                this.BurcarArchivo();
            }
        },
        Siguiente() {
            this.disableR = true;
            if (this.contador == this.paginas) {
                this.contador = this.paginas;
                this.disableR = true;
            }
            else {
                this.loading = true;
                this.loading3 = true;
                this.loading2 = true;
                this.disableR = false;
                this.disableL = false;
                this.contador++;
                if (document.querySelector("iframe") != null) {
                    document.querySelector("iframe").remove();
                }
                this.BurcarArchivo();
            }
        },
        async VerArchivo() {
            let dir = await Archivos.ObtenerDireccion(this.datos, this.docid, 1);
            if (dir.archivo !== null) {
                this.paginas = dir.pagina;
                this.disableR = this.paginas == 1 ? true : false;
                var iframe = document.createElement("iframe");
                iframe.setAttribute("src", dir.watch);
                iframe.style.width = "100%";
                iframe.style.height = "65vh";
                iframe.style.borderRadius = "1%";
                document.getElementById('ver').appendChild(iframe);
            } else {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Error',
                    text: dir.msg,
                    showConfirmButton: false,
                    timer: 2500
                });
                this.verarchi = false;
            }
            this.loading = false;
        },
        async BurcarArchivo() {
            let data = await Archivos.ObtenerDireccion(this.datos, this.docid, this.contador);
            if (data.archivo !== null) {
                var iframe = document.createElement("iframe");
                iframe.setAttribute("src", data.watch);
                iframe.style.width = "100%";
                iframe.style.height = "65vh";
                iframe.style.borderRadius = "1%";
                document.getElementById('ver').appendChild(iframe);
            }
            else {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Error',
                    text: data.msg,
                    showConfirmButton: false,
                    timer: 2500
                });
                this.verarchi = false;
            }
            this.loading2 = false;
            this.loading3 = false;
            this.loading = false;


        },
        async ObtenenerDatosDocumento() {
            this.tipo = this.$route.query.dodescrip
            this.docid = this.$route.query.docid
            this.docarchivo = this.$route.query.docarchivo
            if (this.$route.query.dodescrip == undefined || this.$route.query.docid == undefined) {

                let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
                this.$router.push({ path: asistenciaurl + '/Archivos' });

                //if (this.datos.aiclave == 1) {
                //    this.$router.push({ name: `ArchivosExpJur` });
                //} else if (this.datos.aiclave == 23) {
                //    this.$router.push({ name: `ArchivosRLV` });
                //} else if (this.datos.aiclave == 24) {
                //    this.$router.push({ name: `ArchivosRobo` });
                //}
            } else {
                await this.VerArchivo()
            }

        },
        async Guardar() {
            if (this.$refs.form.validate()) {
                this.disabled = true
                this.$swal({
                    position: 'center',
                    title: 'Guardando calificación, espere un momento....',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                Archivos.CalificarDoc(this, this.datos).then(resp => {
                    this.$swal.close();
                    if (resp.data.length == 0) {
                        this.disabled = true
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se guardó la calificación con éxito.',
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 2500,
                        }).then(async () => {
                            this.back = 1;
                            this.limpiar();
                            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
                            this.$router.push({ path: asistenciaurl + '/Archivos' });
                        })
                    }

                })

            }

        },
        limpiar() {
            this.$refs.form.reset();
        },
        uppercase() {
            if (this.comentarios != '' && this.comentarios != null) {
                this.comentarios = this.comentarios.toUpperCase();
            }
        },
        async Cancelar() {
            this.disabled = true;

            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos' });
            document.querySelector("iframe").remove();
        },
    }
}
</script>

<style scoped>
.containerCD .theme--light.v-card>.v-card__text,
.containerCD .theme--light.v-card>.v-card__subtitle {
    color: rgb(0, 0, 0);
}

.theme--dark.v-card>.v-card__text,
.theme--dark.v-card>.v-card__subtitle {
    color: rgb(255, 255, 255);
}

@media (max-width: 959px) {
    .btnNO {
        display: none;
    }

    .btnSI {
        display: block;
    }
}

@media (min-width: 960px) {
    .btnNO {
        display: flex;
    }

    .btnSI {
        display: none;
    }
}
</style>